export default __webpack_public_path__ + "static/media/warning--railroad-crossing-without-barriers--g2.4806262d.png";